module.exports = __webpack_public_path__ + "media/stylesheets/images/main/openWaiting/openWaiting_mobile_nicole-983fa9d560159bf003f798050ccd54d8.png";